import {Component, Input, OnInit} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {UtilService} from "../../../services/util.service";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss'],
  imports: [
    NgIf,
    NgForOf
  ],
  standalone: true
})
export class CustomTableComponent implements OnInit {

  @Input() broadcast: Broadcast;
  @Input() controlAction: ControlAction;

  constructor(
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
  }

  getTeamBgr(): string {
    return this.utilService.getTeamBgrByGuid(this.broadcast?.customTable?.teamGuid, this.broadcast);
  }
}
